import Vue from "vue";
import store from "./store";
import Router from "vue-router";
import authRouter from "./modules/auth/router";
import clientsRouter from "./modules/clients/router";
import apiKeysRouter from "./modules/apiKeys/router";
import aclRouter from "./modules/acl/router";
import schedulerWorkerReport from "./modules/schedulerWorkers/report/router";
import schedulerWorker from "./modules/schedulerWorkers/workers/router";
import apiCallsRouter from "./modules/apiCalls/router";
import documentationRouter from "./modules/documentation/router";
import dashboardRouter from "./modules/dashboard/router";
import organizationsRouter from "./modules/organizations/router";
import businessGroupsRouter from "./modules/businessGroups/router";
import rules from "./modules/riskEngine/rules/router";
import campaignsRouter from "./modules/riskEngine/campaigns/router";
import productCallsRouter from "./modules/productCalls/router";
import errorsRouter from "./modules/errors/router";
import billingRouter from "./modules/billing/router";
import syncRouter from "./modules/sync/router";
import exportsRouter from "./modules/exports/router";
import notificationsRouter from "./modules/notifications/router";
import clickByDynamicConfigsRouter from "./modules/clickByDynamicConfigs/router"
import apiLimitsRouter from "./modules/apiLimits/router"
import appConfigsRouter from "./modules/appConfigs/router"
import insightModelsRouter from "./modules/insightModels/router"
import trendReportsRouter from "./modules/trendReports/router"
import _ from "lodash";
import PingWatcher from "@/core/utils/pingWatcher";

Vue.use(Router);

const modulesRoute = [
  ...dashboardRouter,
  ...clientsRouter,
  ...apiKeysRouter,
  ...aclRouter,
  ...schedulerWorker,
  ...schedulerWorkerReport,
  ...apiCallsRouter,
  ...documentationRouter,
  ...organizationsRouter,
  ...businessGroupsRouter,
  ...rules,
  ...campaignsRouter,
  ...productCallsRouter,
  ...errorsRouter,
  ...billingRouter,
  ...syncRouter,
  ...exportsRouter,
  ...notificationsRouter,
  ...clickByDynamicConfigsRouter,
  ...apiLimitsRouter,
  ...appConfigsRouter,
  ...insightModelsRouter,
  ...trendReportsRouter,
];
const unknownRoute = {
  path: "*",
  component: () => import("@/core/layouts/Page"),
  children: [
    {
      name: "404 Error",
      path: "",
      component: () => import("@/modules/errors/404"),
    },
  ],
};
const loginRoutes = [
  {
    path: "/user",
    component: () => import("@/core/layouts/Page"),
    meta: {
      usersRoutes: true,
    },
    children: [...authRouter],
  },
  {
    name: "API Endpoint Documentation",
    path: `/docs-endpoint/${process.env.VUE_APP_DOCS_SECURE_KEY}`,
    component: () =>
      import("@/modules/documentation/pages/EndpointDocumentation"),
    meta: {
      usersRoutes: true,
    },
  },
];

const createRouter = (routes) =>
  new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: routes,
  });
const resetRoutes = (abilities) => {
  const newRoutes = [
    {
      path: "/",
      component: () => import("@/core/layouts/PageWithMenu"),
      meta: {
        requiresAuth: true,
      },
      children: modulesRoute.filter((r) => {
        if (r.meta && r.meta.ability) {
          return _.every(r.meta.ability, (value) => {
            return (
              abilities[value.resource] &&
              _.every(
                value.actions,
                (v) => abilities[value.resource].indexOf(v) !== -1
              )
            );
          });
        }
        return true;
      }),
    },
  ]
    .concat(loginRoutes)
    .concat(unknownRoute);
  /* TODO: workaround for reset router. Vue-router has 2 issuess
   * https://github.com/vuejs/vue-router/issues/1156
   * https://github.com/vuejs/vue-router/issues/1234
   */
  const newRouter = createRouter(newRoutes);
  router.matcher = newRouter.matcher; // the relevant part
};

const router = createRouter(loginRoutes);

// eslint-disable-next-line complexity
router.beforeEach((to, from, next) => {
  const abilities = store.getters["core/abilities"];
  const isTempPassword = store.getters["core/isTempPassword"];
  // usersRoutes - login, resetPassword
  if (to.matched.some((record) => record.meta.usersRoutes)) {
    PingWatcher.stopWatch();
    next();
  } else {
    store.commit("core/savePath", to.fullPath);
    if (abilities) {
      PingWatcher.startWatch();
      if (isTempPassword) {
        next("/change-temp-password");
      } else if (to.fullPath === "/") {
        next(store.getters["core/defaultRouter"]);
      } else {
        next();
      }
    } else {
      store.dispatch("core/getUser").then(() => {
        resetRoutes(store.getters["core/abilities"]);
        next(to.fullPath);
      }).catch(() => {});
    }
  }
});
export default router;
